import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoaderType } from './loader.modal';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private loaderTypeSubject = new BehaviorSubject<LoaderType>('none');

  loaderType$ = this.loaderTypeSubject.asObservable();

  setLoader(type: LoaderType) {
    this.loaderTypeSubject.next(type);
  }

  clear() {
    this.loaderTypeSubject.next('none');
  }
}
